import styles from '../styles.module.css';
import PropTypes from 'prop-types';

export const HeaderBox = ({ icon, title, subtitle }) => {
  return (
    <>
      <div className={styles.icon}>
        <img src={icon} alt="icon" width="64" height="64" />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </>
  );
};

HeaderBox.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};
